module.exports = __webpack_public_path__ + "img/5-1_05.4a987fe9.jpg";